import React from 'react'
import {Motion, spring} from 'react-motion'

const springConfig = {stiffness: 350, damping: 20}

class HelpDrawerWrapper extends React.Component{
	
	render(){		
			
		const {showDrawer, drawerType} = this.props

		const style = showDrawer
		    ? {
		       	yTranslate: spring(0, springConfig),		        		        
		       	opacity: spring(1, springConfig),		       	
		      }
		    : { 
	    		yTranslate: spring(50, springConfig),
	    		opacity: spring(0, springConfig),	    		
		      }

		return(
			<Motion style={style}>
			{({yTranslate, opacity}) =>
				<div 
					className={'helpDrawer' + (showDrawer ? ' helpDrawer--open' : ' helpDrawer--closed') + (drawerType ? ` helpDrawer--${drawerType}` : '')}
					style={{ transform: `translateY(${yTranslate}px)`,
               opacity:`${opacity}`}}
            >
						
						{this.props.children}

				</div>			
			}
			</Motion>
		)
	}
}

export default HelpDrawerWrapper

